import request from '@/utils/request'


// 查询转账订单列表
export function listJoe(query) {
  return request({
    url: '/joe/dealer-order/list',
    method: 'get',
    params: query
  })
}

// 查询转账订单分页
export function pageJoe(query) {
  return request({
    url: '/joe/dealer-order/page',
    method: 'get',
    params: query
  })
}

// 查询转账订单详细
export function getJoe(data) {
  return request({
    url: '/joe/dealer-order/detail',
    method: 'get',
    params: data
  })
}

export function getMenuList() {
  return request({
    url: '/joe/dealer-menu/getMenuList',
    method: 'get'
  })
}
// 新增转账订单
export function addJoe(data) {
  return request({
    url: '/joe/dealer-order/add',
    method: 'post',
    data: data
  })
}
export function editOrderStatus(data) {
  return request({
    url: '/joe/dealer-order/editOrderStatus',
    method: 'post',
    data: data
  })
}
// 修改转账订单
export function updateJoe(data) {
  return request({
    url: '/joe/dealer-order/edit',
    method: 'post',
    data: data
  })
}

// 删除转账订单
export function delJoe(data) {
  return request({
    url: '/joe/dealer-order/delete',
    method: 'post',
    data: data
  })
}
